/* TODO: t() */
import React, { Component } from 'react';
import { View, StyleSheet } from 'react-native';
import Text from './Text';
import { themeColors } from './Constants';

type Props = {
  label: string;
  labelStyle?: StyleSet;
  style?: StyleSet;
  children?: ReactElement;
};

export default class ListItem extends Component<Props> {
  render() {
    let { label, style, children, labelStyle } = this.props;
    return (
      <View style={[styles.container, style]}>
        <Text style={[styles.textStyle, labelStyle]}>{label}</Text>
        {children}
      </View>
    );
  }
}

let styles = StyleSheet.create({
  container: {
    marginVertical: 10,
  },
  textStyle: {
    color: themeColors.mainNavText,
    fontSize: 16,
    marginBottom: 5,
  },
});
